import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureAmplify, initializeSentry } from '@/config';
import App from './App';
import './index.css';
// Registers the SVG sprite sheet generated by vite-plugin-svg-icons.
// Must be imported once at the app entry point so that <Icon> components
// can resolve #icon-* symbol references anywhere in the tree.
import 'virtual:svg-icons-register';

// Initialize Sentry error monitoring (before React renders)
initializeSentry();

// Configure AWS Amplify
configureAmplify();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
